/**
 * AI.GEN lines=1-13
 * 配置管理类
 */
import { ConfigBase, CountryCode, EnvironmentName } from '@hpfe/common-base';

export class Config extends ConfigBase {
  constructor() {
    super({
      countryCode: process.env.country as CountryCode,
      environmentName: process.env.environment as EnvironmentName,
    });
  }

  command = process.env.command as string;
}
